import { SwiperModule } from 'angular2-useful-swiper';
import { HomeComponent } from './home.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { routing } from './home.routing';
import { SliderComponent } from '@app/components/slider/slider.component';
import { ProductsComponent } from '@app/components/products/products.component';
import { MobileComponent } from '@app/components/mobile/mobile.component';
import { MenusComponent } from '@app/components/menus/menus.component';
import { fullHeightModule } from '@app/directives/fullHeight.module';
import { AbsolutePathModule } from '@app/pipes/absolute-path/absolute-path.module';
import { LazyLoadModule } from '@app/directives/app-lazy-load.module';
@NgModule({
    imports: [
        CommonModule,
        routing,
        SwiperModule,
        fullHeightModule,
        AbsolutePathModule,
        LazyLoadModule
    ],
    declarations: [
        HomeComponent,
        SliderComponent,
        ProductsComponent,
        MenusComponent,
        MobileComponent
    ],
    exports: [
    ],
    providers:[ ]
})

export class HomeModule {}
